module.exports = __webpack_public_path__ + "h5/img/banner3.2aed5287.png";